import React from 'react';
import styles from './PwaInfoModal.module.css';
import pwaImage from '../assets/images/pwa/pwa.jpg';
import noPwaImage from '../assets/images/pwa/nopwa.jpg';
import oneKeyImage from '../assets/images/pwa/onekey.jpg';

const PwaInfoModal = ({ open, onClose, onAcknowledge }) => {
  if (!open) return null;

  const handleAcknowledge = () => {
    onAcknowledge?.();
    onClose?.();
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(event) => event.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose} aria-label="Close">
          ×
        </button>

        <h2 className={styles.title}>Установка PWA</h2>

        <div className={styles.scrollContent}>
          <p>
            <strong>PWA (Progressive Web Application)</strong> это приложение, которое создаётся
            из сайта и устанавливается в один клик.
          </p>
          <p>
            После установки обычно открывается как отдельное приложение на весь экран: без лишних
            вкладок браузера, с быстрым запуском и удобным интерфейсом.
          </p>
          <p>
            На Apple это удобный способ установить веб-версию как приложение. На Android PWA часто
            выглядит аккуратнее и работает быстрее, чем ожидалось от обычной веб-страницы.
          </p>

          <figure className={styles.figure}>
            <img src={pwaImage} alt="PWA app screen example" className={styles.image} />
            <figcaption className={styles.caption}>Так выглядит интерфейс после установки PWA.</figcaption>
          </figure>

          <figure className={styles.figure}>
            <img src={noPwaImage} alt="Browser mode without PWA" className={styles.image} />
            <figcaption className={styles.caption}>Обычная вкладка браузера без установки.</figcaption>
          </figure>

          <figure className={styles.figure}>
            <img src={oneKeyImage} alt="Install PWA in one tap" className={styles.image} />
            <figcaption className={styles.caption}>Установка обычно доступна в одно нажатие.</figcaption>
          </figure>
        </div>

        <div className={styles.footer}>
          <button className={styles.confirmButton} onClick={handleAcknowledge}>
            Понятно
          </button>
        </div>
      </div>
    </div>
  );
};

export default PwaInfoModal;
